import styled, { css } from "styled-components"
import { transparentize } from "polished"
import breakpoint from "styled-components-breakpoint"
import CloseIcon from "../close-icon"
import Button from "../button"
import ActivityLogTextArea from "../conversations/text-area"

export const StyledDeleteButton = styled(Button)`
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  color: #999 !important;
  font-size: 14px;
`
export const Counter = styled.span`
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1rem;
  min-height: 1rem;
  padding: 0.25rem;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
`

export const StyledButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary} !important;
  fill: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff !important;
  padding: 16px;
`

export const H1 = styled.h1`
  display: flex;
  gap: 0.5rem;
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;
  letter-spacing: -1px;
`

export const ActivityLogContainer = styled.div`
  display: flex;
  height: calc(100vh - 14rem);
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  background: #f7f7f7;
  margin-left: -1.5rem;
  width: 100%;
  position: relative;
  padding-bottom: 6rem;

  ${breakpoint("tablet")`
    margin-left: 2rem;
    border-radius: 16px;
    padding-bottom: 24px;
    width: 260px;
  `}
`

export const MoreOptions = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #999;
  background: #fff;
  color: #666;
  font-size: 24px;
`

export const SidebarActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
`

export const Buttons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  button {
    white-space: normal;
    word-break: break-word;
  }
`

export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${breakpoint("tablet")`
    gap: 24px;
  `}
`

export const Main = styled.main`
  padding: 24px 6% 5rem;
  padding: 24px 6vw 5rem;
  height: 100%;
  overflow-y: visible;

  ${breakpoint("tablet")`
    padding: 24px 24px 5rem;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: start;
    gap: 0;
    padding: 0 0 32px 26px;
    width: calc(100% - 26px);
    display: flex;

    ${({ participantMode }) =>
      participantMode &&
      css`
        margin-top: 12px;
        padding: 0 32px 32px 26px;
        width: calc(100% - 58px);
      `}
  `}
`
export const Aside = styled.aside`
  background-color: ${({ theme }) => theme.colors.primary};
  overflow-y: auto;

  ${({ profile }) =>
    !!profile &&
    css`
      background-color: transparent;
      display: none;

      ${breakpoint("tablet")`
        display: block;
      `}
    `}

  ${breakpoint("tablet")`
    width: 225px;
    max-height: calc(100vh - ${({ contentHeightOffset }) => css`
      ${contentHeightOffset}px
    `} - 48px);
  `}

  ${({ participantMode }) =>
    !participantMode &&
    css`
      padding-top: 32px;
    `}
`

export const Content = styled.div`
  user-select: text;
  flex: 1;
  position: relative;
  padding-top: 8px;
  padding-bottom: 50px;

  ${breakpoint("tablet")`
    overflow-y: auto;
    padding: 0px 32px 0px 64px;
    max-height: calc(100vh - ${({ contentHeightOffset }) => css`
      ${contentHeightOffset}px
    `} - 12px);
  `}
`

export const CurrentSectionTitle = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  position: relative;
  margin-bottom: 1rem;
  padding: 24px 0px 0;
  background: white;
  z-index: 10;
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 22px;
  border-bottom: 1px solid #dddddd;

  ${({ fixed }) =>
    !!fixed &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      padding-left: 1rem;
    `}

  ${breakpoint("tablet")`
    display: none;
  `}
`

export const CurrentSectionHighlight = styled.div`
  width: fit-content;
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: space-between;
`

export const CurrentSectionHighlightText = styled.button`
  display: flex;
  gap: 8px;
  align-items: center;
  border: none;
  background: none;
  padding-left: 0;
  padding-right: 0;
`

export const CurrentSectionChevron = styled.span`
  transition: transform 0.3s ease-in-out;
  transform: rotate(${({ direction }) => (direction === "up" ? "180deg" : "0deg")});
`

export const JumpNav = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px;
  background: white;
  border: 1px solid #e8e8e8;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 8;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`

export const JumpNavButton = styled.button`
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  color: ${({ theme }) => theme.colors.primary};
`

export const CurrentSectionHighlightBorder = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 4px;
  position: relative;
  top: 2px;
`

export const CurrentSectionHeading = styled.h2`
  font-weight: 700;
  font-size: 20px;
  margin: 0;
`

export const ContentWrapper = styled.div`
  border-bottom: 1px solid #dddddd;
  width: 90vw;
  padding-bottom: 2rem;

  ${({ participantMode }) =>
    !participantMode &&
    css`
      padding: 32px 0;
    `}

  &:not(:first-child) {
    padding: 32px 0;
  }
  ${breakpoint("tablet")`
    width: unset;
  `}

  ${({ skipBorder }) =>
    !!skipBorder &&
    css`
      border-bottom: none;
    `}
`

export const ContentMessage = styled.div`
  line-height: 1.4;
  background-color: ${({ theme }) => transparentize(0.9, theme.colors.primary)};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 8px !important;
  padding: 16px 18px;
  margin-bottom: 2rem;
`

export const ContentSection = styled.section``

export const CloseButton = styled(CloseIcon)`
  position: absolute;
  top: 16px;
  right: 32px;
`

export const ActivityLogs = styled.div`
  position: relative;
  flex: 1 1 auto;
  overflow-y: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 0;
  height: 100%;
  margin-bottom: 4rem;
  padding-right: 1rem;

  &::-webkit-scrollbar {
    width: 0.5rem;
    overflow: hidden;
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.lightGrey};
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d8d8d8;
  }
`

export const ActivityLog = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`

export const ActivityLogAvatar = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
`

export const ActivityLogContent = styled.div`
  flex: 1;
  user-select: text;
`

export const ActivityLogUserAction = styled.div`
  font-weight: 400;
  font-size: 16px;
  color: #333333;
`

export const ActivityLogTimestamp = styled.div`
  color: #888;
  font-size: 14px;
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ActivityLogComment = styled.div`
  color: #222;
  font-size: 15px;
  margin: 8px 0;
  line-height: 1.5;
`

export const ActivityLogInputContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  max-width: 100%;
  position: absolute;
  border-top: 1px solid #eee;
  padding: 16px 24px 24px 24px;
  background: #f7f7f7;
  bottom: 0;
  left: 0;
  z-index: 2;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;

  & > div:first-child {
    width: 100%;
  }

  ${({ mobileOnly }) =>
    mobileOnly &&
    css`
      display: flex;
      position: relative;
      padding: 0;
      border-top: none;
      width: 100%;
      align-items: flex-end;
    `}

  ${({ desktopOnly }) =>
    desktopOnly &&
    css`
      display: none;
    `}

  ${breakpoint("tablet")`
    max-width: 260px;

    & > div:first-child {
      max-width: 204px !important;
    }
    ${({ mobileOnly }) =>
      mobileOnly &&
      css`
        display: none !important;
      `}
    ${({ desktopOnly }) =>
      desktopOnly &&
      css`
        display: flex !important;
        align-items: flex-end;
        max-width: 260px;
      `}
  `}
`

export const DropdownMenu = styled.div`
  left: 0;
  bottom: 110%;
  position: absolute;
  background: #fff;
  border: 1px solid #e8e8e8;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  min-width: 150px;
  z-index: 9999;
  padding: 8px 0;
  max-height: 50vh;
  overflow-y: auto;

  ${breakpoint("tablet")`
    top: 110%;
    right: 0;
    left: auto;
    bottom: auto;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-height: none;
    overflow-y: visible;
  `}
`

export const DropdownItem = styled.button`
  padding: 8px 16px;
  cursor: pointer;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  font-weight: ${({ variant }) => (variant === "danger" ? "bold" : "normal")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  font-size: 1rem;
  &:hover {
    background: #f5f5f5;
  }
`

export const MoreOptionsIcon = styled.span`
  display: flex;
  align-items: center;
`

export const StickyMobileFooter = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.07);
  z-index: 100;
  padding: 12px 16px;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
`

export const StickyFooterButton = styled(Button)`
  flex: 1;
  margin-right: 2rem;
  padding: 12px 18px;
`

export const ActivityLogEmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #bdbdbd;
  font-size: 16px;
  width: 100%;
  min-height: 0;
`

export const WhiteBgActivityLogTextArea = styled(ActivityLogTextArea)`
  background: #fff;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex: 1 1 0;
  box-sizing: border-box;
  word-break: break-word;
  overflow-wrap: break-word;

  ${breakpoint("tablet")`
    max-width: 204px;
  `}
`
